/*
 * @Author: ray_sun
 * @Date: 2020-12-10 15:30:46
 */

import Log from '@/utils/log/log'
import Vue from 'vue'
import CONFIG from '@/config'

Log.config({
  app_id: 'fefaaeb52e24835ed1fb03cc038dbf6d', // 从老的 php 项目里拿来
  product_name: 'ccb', // 跟app_id绑定，从老的 php 项目里拿来
  app_version: '1.5.29',
  env: CONFIG.env
})

function stringify(type, trackObj) {
  console.info(`${type}埋点事件：${JSON.stringify(trackObj)}`)
}

// Log.action处理
const originAction = Log.action
const originTrace = Log.trace
const originPage = Log.page

function handle_tracker(type, proxyApplyFunction) {
  return {
    apply: function (target, thisArg, argumentsList) {
      if (__DEV__) {
        stringify(type, { ai: argumentsList[0], d: argumentsList[1] })
      }
      return proxyApplyFunction.call(this, ...arguments)
    }
  }
}

// action和trace的劫持方法
function proxyApply(target, thisArg, argumentsList) {
  return target(argumentsList[0], Object.assign({}, argumentsList[1] || {}))
}

// page的劫持方法
function proxyApply_page(target, thisArg, argumentsList) {
  if (argumentsList.length > 1) {
    Object.assign(argumentsList[1], {})
  }
  // if (!__ONLINE__ && process.env.NODE_ENV === 'production') {
  //   const last_pi = argumentsList.length > 1 ? _.get(argumentsList[1], 'last_page_id') : ''
  // }
  return Reflect.apply(...arguments)
}

if (window.Proxy) {
  Log.trace = new Proxy(originTrace, handle_tracker('Trace', proxyApply))
  Log.action = new Proxy(originAction, handle_tracker('Action', proxyApply))
  Log.page = new Proxy(originPage, handle_tracker('Page', proxyApply_page))
}

Vue.prototype.$log = Log

export { Log }
